import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { RestApiService } from '../shared/rest-api.service';


@Injectable({
  providedIn: 'root'
})
export class SideNavbarService {

  endpoint = 'navigation';

  private closeNavSubject = new Subject<void>();
  closeNav$ = this.closeNavSubject.asObservable();

  constructor(private api: RestApiService) { }

  getNavigationItems(): Observable<any[]> {
    return this.api.getList(this.endpoint);
  }

  getNavigationItem(id: string): Observable<any> {
    return this.api.getOne(this.endpoint, id);
  }

  getLinks(): Observable<any[]> {
    return this.api.getList(this.endpoint + '/links');
  }

  /*getOrganisations(): Observable<any[]> {
    return this.api.getList(this.endpoint);
  }*/

  //Tällä saadaan kontrolloitua valikon sulkemista
  close(): void {
    this.closeNavSubject.next();
  }
}

